import { render } from "./Alert.vue?vue&type=template&id=4e2bc85d"
import script from "./Alert.vue?vue&type=script&lang=ts"
export * from "./Alert.vue?vue&type=script&lang=ts"
script.render = render

export default script